import cx from 'classnames'
import { CardElement } from '@stripe/react-stripe-js'
import {
  StripeCardElementOptions,
  StripeElementChangeEvent,
} from '@stripe/stripe-js'
import CardPaymentMethodEditorViewModel from 'billing/payment-methods/CardPaymentMethodEditorViewModel'
import { Help } from 'components/inputs'
import FormGroup from 'components/inputs/FormGroup'
import { observer } from 'mobx-react'
import * as React from 'react'
import styles from './CardInput.sass'

interface CardInputProps {
  vm: CardPaymentMethodEditorViewModel
  disabled: boolean
}

/**
 * The CardInput
 */
export default observer(function CardInput({ vm, disabled }: CardInputProps) {
  const cardError = vm.validation.getError('card')
  const setCardError = React.useCallback(
    (error: string) => {
      if (!error) {
        vm.validation.clearErrors('card')
      } else {
        vm.validation.clearErrors('card')
        vm.validation.addErrors({ card: [error] })
      }
    },
    [vm],
  )

  const handleChange = React.useCallback(
    (event: StripeElementChangeEvent) => {
      setCardError(event.error?.message || '')
    },
    [setCardError],
  )
  return (
    <FormGroup
      label="Credit or debit card"
      data-test="add-card-form-card-input"
    >
      <CardElement
        onChange={handleChange}
        options={{
          ...CARD_ELEMENT_OPTIONS,
          disabled,
          classes: {
            ...CARD_ELEMENT_OPTIONS.classes,
            // Needed since we also populate errors ourselves.
            base: cx(
              CARD_ELEMENT_OPTIONS.classes?.base,
              cardError && styles.danger,
              disabled && styles.disabled,
            ),
          },
        }}
      />
      <Help error={cardError} />
    </FormGroup>
  )
})

const CARD_ELEMENT_OPTIONS: StripeCardElementOptions = {
  hidePostalCode: true,
  classes: {
    base: styles.control,
    invalid: styles.danger,
    focus: styles.focused,
  },
}
